import fire_event from "@pdfking/workflow/utils/fire_event"
import merge from "rfuncs/functions/merge"
import scan from "rfuncs/functions/scan"

import load from "./api/load"
import ready from "./api/ready"
import settings_extend from "./constants/settings_extend"
import settings_set from "./constants/settings_set"
import deserialize_filelist from "./files/make/deserialize_filelist"
import change_window_location from "./navigation/change_window_location"
import clear_ajax_cache from "./navigation/clear_ajax_cache"
import navigate from "./routes/navigate"
import { FILECHECK_VIEW } from "./routes/urls"
import messages from "./state/messages"
import storage from "./state/storage"
/* EXPOSING WINDOW API */

const exposed_functions = {
  change_window_location,
  clear_ajax_cache,
  settings_set,
  ready,
  load,
  intercom: (command, ...args) =>
    import(
      /* webpackChunkName: "events" */ "@pdfking/frontend/api/modules/intercom"
    ).then(m => m.default[command](...args)),
  tagmanager: (command, ...args) =>
    import(
      /* webpackChunkName: "events" */ "@pdfking/frontend/api/modules/tagmanager"
    ).then(m => m.default[command](...args)),
  settings_done: () => fire_event(document, "site_init"),
  register_event_handler: code => settings_extend("event_handlers", code),
  add_message: message => messages.add(message),
  add_files: files => storage.add_files(deserialize_filelist(files)),
  pdfmodal: async (spec, files) =>
    navigate(
      FILECHECK_VIEW,
      merge(spec, {
        filelist: deserialize_filelist(files),
      })
    ),
}

function push([name, ...a]) {
  return exposed_functions[name](...a)
}

scan(push, window.commands || [])

window.commands = { push }
